import React from 'react';

import { Page, useExecutiveCheckupRouter } from '../../router/context';
import { saveTeleorientationSchedule } from '../../../../modules/slots';
import { useScheduleContext } from '../../../../contexts/ScheduleContext';
import {
  ScheduleRequest,
  createScheduleRequest,
  createScheduleRequestPatientExternal
} from '../../../../models/ScheduleRequest';
import { usePatientContext } from '../../../../contexts/PatientContext';
import { AppointmentConfirmationTemplate } from '../../../../templates/AppointmentConfirmationTemplate';
import TagInfo from '../../../../components/TagInfo';
import { ScheduleCard } from './components/ScheduleCard';
import ModalTimeNotAvailable from '../../../../components/ModalTimeNotAvailable';
import SystemUnavailable from '../../../../components/SystemUnavailable';
import { useServiceContext } from '../../../../contexts/ServiceContext';
import { toast } from 'react-toastify';
import { isOlderThan } from '../../../../utils/validators';
import { usePatientExternal } from '../../../../store/patientExternal';

const WarningBlueIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warningBlue.svg';

type AppointmentConfirmationListProps = {
  isFirstAppointment?: boolean;
};

export function AppointmentConfirmationList({ isFirstAppointment }: AppointmentConfirmationListProps) {
  const router = useExecutiveCheckupRouter();
  const { scheduleItems } = useScheduleContext();
  const { patientSelected } = usePatientContext();
  const { selectedService } = useServiceContext();
  const { patient: externalPatient } = usePatientExternal();

  const [loading, setLoading] = React.useState(false);
  const [isModalSystemUnavailableVisible, setIsModalSystemUnavailableVisible] = React.useState(false);
  const [isModalSlotUnavailableVisible, setIsModalSlotUnavailableVisible] = React.useState(false);

  const saveSchedules = async () => {
    setLoading(true);
    let schedule = {} as ScheduleRequest;

    if (patientSelected || externalPatient) {
      if (patientSelected)
        schedule = createScheduleRequest(patientSelected, scheduleItems, [], isFirstAppointment, selectedService.id);

      if (externalPatient)
        schedule = createScheduleRequestPatientExternal(
          externalPatient,
          scheduleItems,
          isFirstAppointment,
          selectedService.id
        );

      try {
        const scheduleToSave = schedule.schedules.map(item => {
          delete item.serviceId;
          return item;
        });
        await saveTeleorientationSchedule({ ...schedule, schedules: scheduleToSave });

        router.navigate(Page.CONCLUSION, { productId: schedule.schedules[0]?.productId });
      } catch (error: any) {
        console.log('Error trying to schedule/reschedule', error);
        toast.error('Não foi possível realizar o agendamento');
      }
    }
    setLoading(false);
  };

  const checkPediatricPatient = () => {
    if (patientSelected) return !isOlderThan(patientSelected.birthDate, 16);
    return false;
  };

  return (
    <>
      <AppointmentConfirmationTemplate handleContinue={saveSchedules} loading={loading} goBack={() => router.goBack()}>
        {scheduleItems.map(schedule => (
          <>
            <ScheduleCard
              schedule={schedule}
              key={schedule.id}
              isFirstAppointment={!!isFirstAppointment}
              specialist={checkPediatricPatient() ? 'Pediatra' : 'Clínico Geral'}
            />
            {schedule.careType === 'PRESENTIAL' && (
              <div style={{ marginTop: 24 }}>
                <TagInfo
                  info="É recomendado que você chegue na unidade com 15 minutos de antecedência."
                  icon={
                    <img
                      src={WarningBlueIcon}
                      alt="É recomendado que você chegue na unidade com 15 minutos de antecedência."
                    />
                  }
                />
              </div>
            )}
          </>
        ))}
      </AppointmentConfirmationTemplate>

      <ModalTimeNotAvailable
        visible={isModalSlotUnavailableVisible}
        onClose={() => setIsModalSlotUnavailableVisible(false)}
      />

      <SystemUnavailable
        visible={isModalSystemUnavailableVisible}
        onClose={() => setIsModalSystemUnavailableVisible(false)}
      />
    </>
  );
}
